import { Button, Dropdown, Flex, Modal } from 'antd';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react'
import { useUser } from '../../contexts/UserContext';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../redux/Profile/action';
import { FETCH_PRODUCT_LIST, LOGOUT_SUCCESS, CLEAR_ACTIVE_LICENSE } from '../../redux/actions';
import { EDEX_RENEW_URL } from '../../config';
import LoginForm from '../user/LoginForm';
import { Initialize } from '../../hooks/initialize';

const Profile = () => {

    const dispatch = useDispatch();
    const { userConfigs } = useUser();
    const { profileData } = useSelector((state) => state.profile);
    const expireData = profileData?.license?.jalali_expires_at?.split(' ')
    const [licenseModalOpen, setLicenseModalOpen] = useState(false)
    const [open, setOpen] = useState(false)
    const [license, setLicense] = useState(null);


    useEffect(() => {
        if (!profileData) {
            dispatch(getProfile());
        }
        const savedLicense = localStorage.getItem("active_license");
        setLicense(savedLicense);
    }, [profileData]);


    const handleLogout = () => {
        localStorage.removeItem('edexLicenceToken');

        dispatch({
            type: LOGOUT_SUCCESS,
        });
        dispatch({ type: FETCH_PRODUCT_LIST })
        dispatch({ type: CLEAR_ACTIVE_LICENSE })
        Initialize();
    }


    const handleEnterLicense = () => {
        setLicenseModalOpen(true)
    }


    const handleCloseModal = () => {
        setOpen(false);
        setLicenseModalOpen(false)
    };


    const dropdownContent = (
        <div dir={userConfigs?.locale?.locale === 'fa' || userConfigs?.locale?.locale === 'ar' ? 'rtl' : 'ltr'}
            style={{ padding: '15px', borderRadius: '8px', background: userConfigs.dark ? 'black' : 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', display: 'flex', flexDirection: 'column', alignItems: 'start' }}
        >
            <Flex align='center' gap={'small'}>
                <strong>
                    {t('user.email')}:
                </strong>
                <p style={{ margin: '5px 0', color: '#888' }}>{profileData?.email}</p>
            </Flex>
            <Flex align='center' gap={'small'}>
                <strong>
                    {t('search.license')}:
                </strong>
                <div>
                    {
                        profileData?.license === null ?
                            <Flex align='center' gap={'small'}>
                                <p style={{ fontSize: '13px', whiteSpace: 'nowrap' }}> {t('user.license_expired')}</p>
                                <Button onClick={handleEnterLicense} type="primary" className="extention-btn" size="small" style={{ width: '100%', margin: '10px auto', padding: '10px 10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{t('user.enter_license_code')}</Button>
                            </Flex>
                            :
                            <Flex align='center' style={{ margin: '5px 0', color: '#888' }}>
                                <p style={userConfigs.locale.locale === 'fa' || userConfigs?.locale?.locale === 'ar' ? { marginLeft: '4px' } : { marginRight: '4px' }}>{expireData && expireData[0]}</p>
                                <Flex align='center'>
                                    (<p style={{ margin: '4px' }}>{profileData?.license?.remaining_days}</p>
                                    <p style={userConfigs.locale.locale === 'fa' || userConfigs?.locale?.locale === 'ar' ? { marginLeft: '4px' } : { marginRight: '4px' }}>
                                        {t('user.days')}
                                    </p>)
                                </Flex>
                            </Flex>

                    }
                </div>
            </Flex>
            {
                profileData?.license !== null &&
                <Flex align='center' gap={'small'}>
                    <strong>
                        {t('user.license_code')}:
                    </strong>
                    <p style={{ margin: '5px 0', color: '#888' }}>{license}</p>
                </Flex>
            }

            <Button type="primary" size="small" style={{ width: '50%', margin: '10px auto', padding: '0px opx' }} onClick={handleLogout}>
                {t('user.logout')}
            </Button>
        </div>
    );


    return (
        <>
            <Dropdown overlay={dropdownContent} trigger={['click', 'hover']} placement="bottomRight">
                <Button size="middle" className="user-btn">
                    <span className='profileTextHeader'>{t('user.profile')}</span>
                    <span className="btn-icon svg-icon icon-user2" />
                </Button>
            </Dropdown>

            <Modal
                open={licenseModalOpen}
                onCancel={handleCloseModal}
                footer={null}
                className="white-modal"
                width={590}
                styles={{ mask: { backdropFilter: 'blur(10px)' } }}
            >
                <LoginForm setLicenseModalOpen={setLicenseModalOpen} />
            </Modal>
        </>
    )
}

export default Profile